import React, { Component } from 'react';

class TableRow extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let modifiedLimit = this.props.modifiedLimit;
        return (
            <tr>
                <td className="gris-obscuro">
                    <label><i>{modifiedLimit.administradora}</i></label>
                </td>
                <td className="td-bold td-bold-black">
                    <label><i>{modifiedLimit.ambito}</i></label>
                </td>
                <td className="td-bold td-bold-black">
                    <label><i>{modifiedLimit.limiteAnterior}</i></label>
                </td>
                <td className="td-bold td-bold-black">
                    <label><i>{modifiedLimit.limiteNuevo}</i></label>
                </td>
            </tr>
        );
    }
}

export default TableRow;